import { APICall } from ".."

const ControllerName = "MobPatientMedicalHistory"

export const GetPatientMedicalHistory = (searchData: any) => {

    let keyword = searchData?.keyword
    let textKeyword = searchData?.textKeyword

    return APICall("get", ControllerName + `/GetPatients?keyword=${keyword||""}&textKeyword=${textKeyword||""}`)
}

export const GetPatientHospitals = (patientId: number) => {
    return APICall("get", ControllerName + `/GetPatientHospitals/${patientId}`)
}

export const GetPatientHistory = (patientId: number) => {
    return APICall("get", ControllerName + `/history/${patientId}`)
}

export const SubmitNewDiagnosis = (data: any) => {
    return APICall("post", ControllerName + "/SubmitNewDiagnosis", data)
}
